var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        { staticClass: "primary", attrs: { dark: "" } },
        [
          _vm.$vuetify.breakpoint.mdAndDown
            ? _c("v-toolbar-side-icon", {
                nativeOn: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.sideNav = !_vm.sideNav
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-toolbar-title",
            { staticClass: "nar" },
            [
              _c(
                "v-layout",
                { attrs: { "align-center": "" } },
                [
                  _vm.isShowLogo("production")
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/vite-logo.jpg"),
                          alt: "",
                          height: "36px"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowLogo("far800") && _vm.currentLang === "en"
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/maximus-en.png"),
                          alt: "",
                          height: "96px"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowLogo("far800") && _vm.currentLang === "zhHans"
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/maximus-ch.png"),
                          alt: "",
                          height: "90px"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowLogo("fsd915")
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/fsd915.png"),
                          alt: "",
                          height: "36px"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowLogo("eagle")
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/shiprateshop.png"),
                          alt: "",
                          height: "96px"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    { staticClass: "ml-3", attrs: { left: "", dark: "" } },
                    [_vm._v(_vm._s(_vm.userIcon))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("PromotionWidget"),
          _vm._v(" "),
          _vm.isUserLogined && !_vm.isAdmin
            ? _c("AnnouncementWidget")
            : _vm._e(),
          _vm._v(" "),
          !_vm.$vuetify.breakpoint.mdAndDown
            ? _c(
                "v-toolbar-items",
                [
                  _vm._l(
                    _vm.items.filter(function(item) {
                      return !item.disabled
                    }),
                    function(item) {
                      return [
                        !item.link && item.subItems
                          ? _c(
                              "v-menu",
                              {
                                key: item.link,
                                class: "hidden-sm-and-down",
                                attrs: { "offset-y": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                class: _vm.getManualClass(item),
                                                attrs: {
                                                  flat: "",
                                                  dark: "",
                                                  id: item.name
                                                }
                                              },
                                              data.on
                                            ),
                                            [_vm._v(_vm._s(item.name))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass: "primary",
                                      attrs: { dark: "" }
                                    },
                                    [
                                      _vm._l(item.subItems, function(subItem) {
                                        return [
                                          !subItem.disabled
                                            ? _c(
                                                "v-list-tile",
                                                {
                                                  key: subItem.title,
                                                  attrs: { id: subItem.name },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.menuClick(
                                                        subItem
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(_vm._s(subItem.name))
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ]
                              ],
                              2
                            )
                          : _c(
                              "v-btn",
                              {
                                key: item.link,
                                attrs: { flat: "", dark: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.menuClick(item)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(item.name))]
                            )
                      ]
                    }
                  ),
                  _vm._v(" "),
                  _vm.isUserLogined
                    ? _c(
                        "v-menu",
                        {
                          class: "hidden-sm-and-down",
                          attrs: { "offset-y": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      {
                                        staticStyle: { "box-shadow": "none" },
                                        attrs: { color: "primary" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return on.click.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { dark: "" } }, [
                                          _vm._v("manage_accounts")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2075612420
                          )
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { staticClass: "primary", attrs: { dark: "" } },
                            [
                              _vm._l(_vm.accounts, function(account) {
                                return _c(
                                  "v-list-tile",
                                  { key: account.key },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { flat: "", dark: "" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.switchToAccount(
                                              account.name
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { left: "", dark: "" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.staffIcons(account.role)
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(account.name) +
                                            "\n            "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _vm.mainAccount || _vm.isUser
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { flat: "", dark: "" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              _vm.switchToAccount(
                                                (_vm.mainAccount &&
                                                  _vm.mainAccount.name +
                                                    "--Individual") ||
                                                  (_vm.$store.getters
                                                    .userExtra &&
                                                    _vm.$store.getters.userExtra
                                                      .name + "--Individual")
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "", dark: "" } },
                                            [_vm._v("perm_identity")]
                                          ),
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.$t("individual")) +
                                              "\n            "
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isAdmin
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            to: "/profile",
                                            flat: "",
                                            dark: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "", dark: "" } },
                                            [_vm._v("account_circle")]
                                          ),
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.$t("profile")) +
                                              "\n            "
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                [
                                  _vm.isUserLogined
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            flat: "",
                                            dark: "",
                                            id: "logout"
                                          },
                                          on: { click: _vm.onLogout }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "", dark: "" } },
                                            [_vm._v("exit_to_app")]
                                          ),
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.$t("logout")) +
                                              "\n            "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { flat: "" }, on: { click: _vm.switchLang } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.currentLang === "en" ? "中文" : "English"
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-navigation-drawer",
        {
          attrs: { temporary: "", absolute: "" },
          model: {
            value: _vm.sideNav,
            callback: function($$v) {
              _vm.sideNav = $$v
            },
            expression: "sideNav"
          }
        },
        [
          _c(
            "v-list",
            [
              _vm._l(
                _vm.items.filter(function(item) {
                  return item.isShownOnSmallDevices && !item.disabled
                }),
                function(item) {
                  return [
                    !item.link && item.subItems
                      ? _c(
                          "v-list-group",
                          {
                            key: item.link,
                            attrs: { "no-action": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [_c("v-icon", [_vm._v("tablet")])],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-content", [
                                            _vm._v(_vm._s(item.name))
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: item.active,
                              callback: function($$v) {
                                _vm.$set(item, "active", $$v)
                              },
                              expression: "item.active"
                            }
                          },
                          [
                            _vm._v(" "),
                            _vm._l(
                              item.subItems.filter(function(item) {
                                return (
                                  item.isShownOnSmallDevices && !item.disabled
                                )
                              }),
                              function(subItem) {
                                return _c(
                                  "v-list-tile",
                                  {
                                    key: subItem.name,
                                    on: {
                                      click: function($event) {
                                        return _vm.$router.push(subItem.link)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v(_vm._s(subItem.name))
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }
                            )
                          ],
                          2
                        )
                      : _c(
                          "v-list-tile",
                          {
                            key: item.link,
                            on: {
                              click: function($event) {
                                return _vm.$router.push(item.link)
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-tile-action",
                              [_c("v-icon", [_vm._v("tablet")])],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-list-tile-content", [
                              _vm._v(_vm._s(item.name))
                            ])
                          ],
                          1
                        )
                  ]
                }
              )
            ],
            2
          ),
          _vm._v(" "),
          _vm.isUserLogined
            ? _c(
                "v-list",
                [
                  _c(
                    "v-list-group",
                    {
                      attrs: { "no-action": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function() {
                              return [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c(
                                      "v-list-tile-action",
                                      [
                                        _c("v-icon", [
                                          _vm._v("manage_accounts")
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-list-tile-content", [
                                      _vm._v("Accounts")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3541454181
                      )
                    },
                    [
                      _vm._v(" "),
                      _vm._l(_vm.accounts, function(account) {
                        return _c(
                          "v-list-tile",
                          {
                            key: account.key,
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.switchToAccount(account.name)
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-tile-action",
                              [
                                _c("v-icon", [
                                  _vm._v(_vm._s(_vm.staffIcons(account.role)))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              [
                                _c("v-list-tile-title", [
                                  _vm._v(_vm._s(account.name))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.mainAccount || _vm.isUser
                        ? _c(
                            "v-list-tile",
                            {
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.switchToAccount(
                                    (_vm.mainAccount && _vm.mainAccount.name) ||
                                      (_vm.$store.getters.userExtra &&
                                        _vm.$store.getters.userExtra.name)
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-tile-action",
                                [_c("v-icon", [_vm._v("perm_identity")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-tile-content", [
                                _vm._v(_vm._s(_vm.$t("individual")))
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isAdmin
                        ? _c(
                            "v-list-tile",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.$router.push("profile")
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-tile-action",
                                [_c("v-icon", [_vm._v("account_circle")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-tile-content", [
                                _vm._v(_vm._s(_vm.$t("profile")))
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isUserLogined
                        ? _c(
                            "v-list-tile",
                            {
                              attrs: { id: "logout" },
                              on: { click: _vm.onLogout }
                            },
                            [
                              _c(
                                "v-list-tile-action",
                                [_c("v-icon", [_vm._v("exit_to_app")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-tile-content", [
                                _vm._v(_vm._s(_vm.$t("logout")))
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list",
            [
              _c(
                "v-list-tile",
                { on: { click: _vm.switchLang } },
                [
                  _c(
                    "v-list-tile-action",
                    [_c("v-icon", [_vm._v("translate")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-list-tile-content", [
                    _vm._v(
                      _vm._s(_vm.currentLang === "en" ? "中文" : "English")
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-footer",
            [
              _c(
                "v-layout",
                [
                  _c("v-spacer"),
                  _c("v-flex", { attrs: { md4: "" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("version")) + ": " + _vm._s(_vm.version)
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              attrs: { top: true, color: _vm.toastColor, timeout: 30000 },
              model: {
                value: _vm.toastEnable,
                callback: function($$v) {
                  _vm.toastEnable = $$v
                },
                expression: "toastEnable"
              }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.toastText) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.closeToast.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("X")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isReloadNeeded
        ? _c("SimpleTextPopup", {
            attrs: {
              hideLftBtn: "",
              title: _vm.$t("newRelease"),
              rightButtonText: _vm.$t("reload"),
              rightMethod: _vm.reloadPage
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-flex",
                            { staticStyle: { "white-space": "pre-wrap" } },
                            [_vm._v(_vm._s(_vm.reloadPageText))]
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2650977287
            ),
            model: {
              value: _vm.isReloadNeeded,
              callback: function($$v) {
                _vm.isReloadNeeded = $$v
              },
              expression: "isReloadNeeded"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isSysUpdating
        ? _c("SimpleTextPopup", {
            attrs: { hideLftBtn: "", hideRgtBtn: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-center": "" } },
                            [
                              _c("v-progress-circular", {
                                attrs: { indeterminate: "", color: "primary" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticStyle: { "white-space": "pre-wrap" } },
                            [_vm._v(_vm._s(_vm.updatingText))]
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3503190661
            ),
            model: {
              value: _vm.isSysUpdating,
              callback: function($$v) {
                _vm.isSysUpdating = $$v
              },
              expression: "isSysUpdating"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { fullscreen: "", "full-width": "" },
          model: {
            value: _vm.submitting,
            callback: function($$v) {
              _vm.submitting = $$v
            },
            expression: "submitting"
          }
        },
        [
          _c(
            "v-container",
            {
              staticStyle: { "background-color": "rgba(255, 255, 255, 0.75)" },
              attrs: { fluid: "", "fill-height": "" }
            },
            [
              _c(
                "v-layout",
                { attrs: { "justify-center": "", "align-center": "" } },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.applyFeature
        ? _c(
            "FormSubmitPopup",
            {
              attrs: {
                title: _vm.$t("featureApplication"),
                leftButtonText: _vm.$t("back"),
                leftMethod: _vm.goBack,
                medium: "",
                isShowSettingIcon: false,
                isEscClose: false,
                hideRgtBtn: _vm.existApplication,
                rightButtonDisabled: _vm.uploadFiles.length < 1,
                rightMethod: _vm.submitApplication,
                rightButtonText: _vm.$t("submit")
              },
              on: {
                popupClose: function($event) {
                  _vm.applicationDialog = false
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "input",
                    fn: function() {
                      return [
                        _c(
                          "v-container",
                          [
                            _vm.existApplication
                              ? _c(
                                  "v-layout",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          row: "",
                                          "align-center": "",
                                          "justify-space-around": ""
                                        }
                                      },
                                      [
                                        _c("div", { staticClass: "title" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "featureApplicationPending"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            on: {
                                              click: _vm.showCommentsDialog
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("clickToSupport"))
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.commentsDialog
                                      ? _c("ChatRoom", {
                                          attrs: {
                                            docPath: [
                                              "featureApplication",
                                              _vm.featureApplication._key
                                            ],
                                            comments:
                                              _vm.featureApplication.comments,
                                            createConnection: true
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "issue",
                                                fn: function() {
                                                  return [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        attrs: {
                                                          hover: "",
                                                          raised: ""
                                                        }
                                                      },
                                                      [
                                                        _c("v-card-text", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cardTitle",
                                                              staticStyle: {
                                                                "overflow-wrap":
                                                                  "break-word"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "createTime"
                                                                  )
                                                                ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    _vm.toTimestampString(
                                                                      _vm
                                                                        .featureApplication
                                                                        .createTime
                                                                    )
                                                                  )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cardTitle",
                                                              staticStyle: {
                                                                "overflow-wrap":
                                                                  "break-word"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "tenant"
                                                                  )
                                                                ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .featureApplication
                                                                      .name
                                                                  )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cardTitle",
                                                              staticStyle: {
                                                                "overflow-wrap":
                                                                  "break-word"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "featureApplication"
                                                                  )
                                                                ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .featureApplication
                                                                      .feature
                                                                  )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cardTitle",
                                                              staticStyle: {
                                                                "overflow-wrap":
                                                                  "break-word"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "files"
                                                                    )
                                                                  ) +
                                                                  ":\n                    "
                                                              ),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.downloadFile(
                                                                        _vm
                                                                          .featureApplication
                                                                          .uploadFiles[0]
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .featureApplication
                                                                        .uploadFiles[0]
                                                                        .name
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            false,
                                            3543968902
                                          ),
                                          model: {
                                            value: _vm.commentsDialog,
                                            callback: function($$v) {
                                              _vm.commentsDialog = $$v
                                            },
                                            expression: "commentsDialog"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _c(
                                  "v-layout",
                                  {
                                    attrs: {
                                      "align-center": "",
                                      "justify-center": "",
                                      "fill-height": "",
                                      column: ""
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("featureApplicationTips"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-container",
                                      {
                                        staticClass: "downLoadBox",
                                        attrs: { fluid: "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { sm12: "", md4: "" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  large: "",
                                                  color: "primary",
                                                  flat: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.downloadTemplate.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mx-2",
                                                    attrs: {
                                                      dark: "",
                                                      large: ""
                                                    }
                                                  },
                                                  [_vm._v("cloud_download")]
                                                ),
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t("downloadTemplate")
                                                    ) +
                                                    "\n                "
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("UploadFileWidget", {
                                      ref: "fileUploader",
                                      attrs: { type: "file", maxFiles: 1 },
                                      model: {
                                        value: _vm.uploadFiles,
                                        callback: function($$v) {
                                          _vm.uploadFiles = $$v
                                        },
                                        expression: "uploadFiles"
                                      }
                                    })
                                  ],
                                  1
                                )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                686135042
              ),
              model: {
                value: _vm.applicationDialog,
                callback: function($$v) {
                  _vm.applicationDialog = $$v
                },
                expression: "applicationDialog"
              }
            },
            [_vm._v("\n    >\n      ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41458b80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41458b80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = null
// module chunks = 